import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig } from 'src/environments/environment.interface';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {
  facilityConfig: FacilityConfig = {} as FacilityConfig;

  defaultFaqs: any[] = [];

  dropfitnessFaqs = [
    {
      title: 'About Drop Fitness',
      items: [
        {
          title: 'How is Drop Fitness different than other gyms?',
          content: '<div>Drop Fitness puts you in control of your fitness journey. We do not have salespeople. Simply download the Drop Fitness app to become a member and enjoy one week free. From there, you can purchase any service either individually or as a subscription. Subscriptions can be turned on and off with a tap of a button.</div>',
        },
        {
          title: 'What does Drop Fitness offer?',
          content: '<div>Drop Fitness curates the best offerings in fitness and wellness. We have partnered with some of the most loved boutique fitness brands, personal trainers, equipment manufacturers, healthy food purveyors, and retail outlets to bring you our favorite products and services. Wish we carried a certain brand? Please let us know.</div>',
        },
        {
          title: 'What do I get with my first week free?',
          content: '<div>First week free includes unlimited classes and unlimited access to our cardio + weights floor.</div>',
        },
        {
          title: 'When does my first week free begin?',
          content: '<div>After you check in for the first time.</div>',
        },
        {
          title: 'How do I check in for the first time?',
          content: '<div>Please visit us at any time and our friendly front desk staff will be sure to get you checked in. First time check in requires a valid photo ID and a security photo. Collecting this information allows us to maintain the security of the club and enforce that our members treat the club and its members respectfully.</div> <div>&nbsp;</div><div>To check in for the first time and any time after, open the app and tap on the QR code on the right side of the home screen. Place the QR code underneath the scanner on the front desk to check in.</div>',
        },
        {
          title: 'How can I see your pricing menu?',
          content: '<div>To see prices for the services we offer, tap on your photo in top left corner to access the menu and then select "My Drop". From there, tap on any of our services to see pricing.</div><div>&nbsp;</div><div>Our prices are always accessible and transparent. Drop Fitness does not have any hidden fees.</div>',
        },
        {
          title: 'Do I need to be a member to make café or retail purchases?',
          content: '<div>No. The café and retail sections of Drop Fitness are located in front of the check in desk and are accessible to the public.</div>',
        },
        {
          title: 'How do I invite friends and family to become members of Drop Fitness?',
          content: '<div>Tap on the "Invite Friends &amp; Family" widget on the home tab.</div>',
        },
        {
          title: 'How do I cancel my membership?',
          content: '<p><span class="wysiwyg-color-black">At Drop Fitness, you\'re not locked into a traditional membership contract or required to pay monthly membership fees. Once you\'re registered as a member, you can come and go as you please, paying only for what you\'re using at the time.</span></p> <p><span class="wysiwyg-color-black">We value your privacy. If you need to permanently close your account and request that we delete the personal information associated with it (name, email, phone number, etc.), then you can do so from within the app. Simply tap on your photo, go into Edit Profile, open Account Status, and tap "Delete Account" to begin the process.</span></p> <p><span class="wysiwyg-color-black" style="font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Helvetica, Arial, sans-serif;">After submitting your request, you won\'t be able to access any of the services that you would normally enjoy as a Drop Fitness member. That includes checking in to any already-booked classes and training sessions, or using the open gym. </span><span class="wysiwyg-color-black">Any active subscriptions will be cancelled, so that you won\'t continue to be charged for them.</span></p> <p><span class="wysiwyg-color-black">Access to the Drop Café is and will continue to be available to you as a member of the general public.</span></p> <p><span class="wysiwyg-color-black">We will initiate account deletion 7 days after we receive your request. At that point, any unused credits will be permanently lost. We will send you a confirmation text message and an email, once this process is completed.</span></p> <p><span class="wysiwyg-color-black">If you decide to come back at any time after account deletion, then please contact us in advance so that we can help you get set up with a new account.</span></p> <p></p>',
        }
      ]
    },
    {
      title: 'Studios',
      items: [
        {
          title: 'How are Drop Fitness Studios different than what I would find at other gyms?',
          content: '<div>Drop Fitness partners with the best boutique fitness studios and brings them to you all under one roof. Studio classes are offered à la carte or as a subscription.</div>',
        },
        {
          title: 'How are Drop Fitness Studios different than what I would find at other boutique studios?',
          content: '<div>Drop Fitness offers four boutique fitness studios under one roof and amenities not found at most other boutique studios such as cardio + free weights, kids club, café, and luxury locker rooms.</div>',
        },
        {
          title: 'How do I book a class?',
          content: '<div>In the studios tab, tap the "+" icon to see our schedule for that day. Tap on any class to initiate the booking process. Tap any date on the calendar to see the schedule for that day.</div>',
        },
        {
          title: 'Can class packages and subscriptions be used across all studios?',
          content: '<div>Yes.  All class packages and subscriptions can be used across all of our studios.</div>',
        },
        {
          title: 'Can I use the cardio machines and free weights on days I book a class?',
          content: '<div>Class subscriptions come with unlimited access to our cardio and free weights floor.</div><div>Class packages do <span class="wysiwyg-underline">not</span> come with access to the cardio and free weights floor.</div>',
        },
        {
          title: 'Can I use the kids club on days I book a class?',
          content: '<div>Yes. We are currently offering kids club complementary with all class package and subscription purchases. Kids club access is on a first come first served basis. Children can be left in our kids club for up to 1 hour.</div>',
        },
        {
          title: 'Can I invite my friends to join me in class?',
          content: '<div>Yes.  We love it when our members invite their friends to a class.  To invite a friend, tap on your upcoming class in the "up next" widget on the home screen.  From there you will see the link to "invite friends".</div>',
        },
        {
          title: 'Can I change my spot in class?',
          content: '<div>Once you arrive to the class the check in staff will be able to change your spot if an empty spot is available.</div>',
        },
        {
          title: 'What is the class cancellation policy?',
          content: '<div>If you need to cancel a class, please cancel 4 hours before your class begins to avoid getting charged a no-show fee. Late cancellation is subject to a fee.</div>',
        },
        {
          title: 'Can I arrive late to a class?',
          content: '<div>We encourage you to arrive 15 minutes prior to the start of class so you can check in and get ready. Our studios extend a 5 minute grace period to enter the studio after class has started.</div>',
        },
        {
          title: 'When do class packages expire?',
          content: '<div>Class packages expire 1 year from the purchase date.</div>',
        },
        {
          title: 'How do I cancel a subscription?',
          content: '<div>Tap your profile photo. Tap on "My Drop". Tap on the active subscription. Tap cancel. Drop Fitness will not charge you on the next billing cycle start date.</div>',
        }
      ]
    },
    {
      title: 'Personal Training',
      items: [
        {
          title: 'How is Drop Fitness Personal Training different than what I would find at other gyms?',
          content: '<div>We don\'t charge membership dues on top of personal personal training fees. We also have a dedicated personal training area with top of the line equipment so you never have to wait for a piece of equipment being used by someone who isn\'t personal training.</div>',
        },
        {
          title: 'How do I get started with Personal Training?',
          content: '<p>Please go to the trainer tab in the app and choose which trainer is right for you. Our personal trainer will be in touch in the next 24 hours to schedule your complimentary needs assessment appointment.</p>',
        },
        {
          title: 'Do you offer an initial personal training assessment?',
          content: '<div>Yes. Your first session is a complementary needs assessment appointment that a trainer can use to learn more about your training goals. During the assessment, you and your trainer will discuss your goals and set a plan of action.</div>',
        },
        {
          title: 'How long is a training session?',
          content: '<div>A training session is 60 minutes.</div>',
        },
        {
          title: 'Where do I check in to a personal training session?',
          content: '<div>Please meet your trainer in the private training area by the benches.</div>',
        }
      ]
    },
    {
      title: 'Cardio Machines + Free Weights',
      items: [
        {
          title: 'How do I access cardio machines and free weights?',
          content: '<div>Members have two options to access our cardio and free weights floor:</div> <div> <br>Option 1: We offer a cardio + weights subscription that gives members monthly access to cardio and free weights.</div> <div></div> <div>Option 2: Class subscriptions come with unlimited access to our cardio and free weights floor.</div>',
        },
        {
          title: 'Does a Cardio + Weights subscription give me access to Studios or Personal Training?',
          content: '<div>No. If you like to use cardio machines and free weights on your own, then a Cardio + Weights subscription may be for you. If you like classes, personal training, or our other services then we offer those independent of a Cardio + Weights subscription.</div>',
        }
      ]
    },
    {
      title: 'Kids Club',
      items: [
        {
          title: 'Where is your kids club located?',
          content: '<div>The kids club is located behind the front desk.</div>',
        },
        {
          title: 'How do I access the kids club?',
          content: '<div>Please check in at the front desk who will direct you to the kids club. Parents can drop off up to 1 child at the kids club on a first come first served basis.  Parents are required to sign a waiver the first time they drop a child off at the kids club. Every child must be signed in to the kids club on every visit.</div>',
        },
        {
          title: 'How do I access the kids club?',
          content: '<div>Please check in at the front desk who will direct you to the kids club. Parents can drop off up to 1 child at the kids club on a first come first served basis.  Parents are required to sign a waiver the first time they drop a child off at the kids club. Every child must be signed in to the kids club on every visit.</div>',
        },
        {
          title: 'Is the kids club free if I have a scheduled class or personal training session on that day?',
          content: '<div>For now we are offering kids club as a complementary service if you have purchased a package or subscription.</div>',
        },
        {
          title: 'How long can I leave my child at the kids club?',
          content: '<div>We ask that you pick your child up at the kids club after an hour of working out so we can provide this service for all of our members.</div>',
        },
        {
          title: 'What happens if my child needs me when I\'m working out?',
          content: '<p>When checking your child into kids club you will receive a buzzer. If your child needs you we will send you a buzz. In an emergency, we will also come find you.</p>',
        }
      ]
    }
  ];

  steelhausFaqs = [
    {
      title: 'Memberships & Pricing',
      items: [
        {
          title: 'What types of memberships does Steelhaus offer?',
          content: '<div>We offer three flexible membership options: Steel 4x (4 rides per month), Steel 8x (8 rides per month), and Steel Unlimited (unlimited rides each month). All memberships include priority booking, exclusive member perks, and access to our studio amenities.</div>',
        },
        {
          title: 'Can I purchase a single class without a membership?',
          content: '<div>Yes! We offer class packs and drop-in rides for those who want flexibility without a recurring membership.</div>',
        },
        {
          title: 'Do memberships auto-renew?',
          content: '<div>Yes, memberships renew automatically each month to make sure you never lose your spot. You can manage or update your plan anytime through your account.</div>',
        }
      ]
    },
    {
      title: 'Booking & Classes',
      items: [
        {
          title: 'How do I book a class?',
          content: '<div>Simply log in to your Steelhaus account on our website or mobile app, view the schedule, and reserve your ride. We recommend booking early as classes fill quickly.</div>',
        },
        {
          title: 'What types of classes do you offer?',
          content: '<div>Our core class formats include Rhythm, Inspire, Ignite, and Chisel—each designed to push, inspire, and energize you in a different way.</div>',
        },
        {
          title: 'How early should I arrive for class?',
          content: '<div>We recommend arriving at least 15 minutes early to check in, get fitted on your bike, and settle into the studio. First-time riders should arrive 20 minutes early.</div>',
        }
      ]
    },
    {
      title: 'Studio Experience',
      items: [
        {
          title: 'Do you provide cycling shoes?',
          content: '<div>Yes! Complimentary cycling shoes are provided for Steelhaus members. For ClassPass riders, shoe rentals are available for $5 per class. You\'re also welcome to bring your own SPD-compatible shoes.</div>',
        },
        {
          title: 'What should I bring to class?',
          content: '<div>Just bring water and your energy. We provide towels, lockers, and all the equipment you\'ll need.</div>',
        },
        {
          title: 'Is Steelhaus beginner-friendly?',
          content: '<div>Absolutely. Our instructors will help you set up your bike, and every class is designed so you can ride at your own pace.</div>',
        }
      ]
    },
    {
      title: 'Policies & Perks',
      items: [
        {
          title: 'What is your cancellation policy?',
          content: '<div>Classes can be canceled up to 12 hours in advance without penalty. Late cancellations or no-shows may result in a fee.</div>',
        },
        {
          title: 'Do you offer corporate or group packages?',
          content: '<div>Yes! Steelhaus offers private rides, team sessions, and corporate packages. Reach out to operations@steelhauscycle.com for details.</div>',
        },
        {
          title: 'What other benefits come with membership?',
          content: '<div>Members enjoy priority booking, access to exclusive sales, and special new member pricing on select offers.</div>',
        }
      ]
    }
  ];

  fitnessfactoryFaqs = [
    {
      title: 'About Fitness Factory Harlem',
      items: [
        {
          title: 'What is Fitness Factory Harlem?',
          content:
            'We’re the newest addition to the Fitness Factory family — bringing a full-service gym to the heart of Harlem with premium equipment, expert trainers, and a community-focused fitness experience.',
        },
        {
          title: 'Is the gym open?',
          content:
            'Yes! Please come in any time during our operating hours and ask for a tour! No appointment is necessary, simply come in and explore our state of the art facility!',
        },
        {
          title: 'Where are we located?',
          content:
            'You’ll find us at 362 West 125th Street, New York, NY 10027 — right in the heart of Harlem.',
        },
        {
          title: 'What are our hours?',
          content:
            'Once open, our planned hours will be:\nMon–Thu: 5:00 AM – 10:00 PM\nFri: 5:00 AM – 9:00 PM\nSat: 7:00 AM – 8:00 PM\nSun: 7:00 AM – 5:00 PM',
        },
      ],
    },
    {
      title: 'Facilities & Amenities',
      items: [
        {
          title: 'What amenities will we offer?',
          content:
            'Our Harlem location will offer a full suite of strength and cardio equipment, a variety of group fitness classes including yoga, HIIT, and more, as well as certified personal training programs designed to help members reach their goals. Members will also enjoy access to locker rooms with showers and a relaxing sauna, free Wi-Fi, and a clean, modern environment—plus a convenient juice bar to refuel after every workout.',
        },
        {
          title: 'Will there be group fitness classes?',
          content:
            'Absolutely. Our schedule will include a variety of group classes such as yoga, Zumba, sculpt, and strength training, designed for all fitness levels.',
        },
        {
          title: 'What’s included in the app?',
          content:
            'Our Fitness Factory app lets you check in, manage your membership, view schedules, and book classes + training sessions. You’ll receive download links before we open.',
        },
      ],
    },
    {
      title: 'Memberships & Pricing',
      items: [
        {
          title: 'How can I join?',
          content:
            'You can join right now during our pre-sale period to lock in exclusive founding rates. Your membership will activate as soon as we open, and you’ll receive setup details by email.',
        },
        {
          title: 'What types of memberships are available?',
          content:
            'We offer flexible month-to-month, 12-month memberships, and annual memberships, with add-ons for personal training available. Pricing and details are listed on our membership page during pre-sale.',
        },
        {
          title: 'Can I freeze or cancel my membership?',
          content:
            'Membership freezes and cancellations will follow the policies outlined in your agreement. We make the process easy through your account or by contacting our team directly.',
        }
      ],
    },
    {
      title: 'Personal Training & Programs',
      items: [
        {
          title: 'Can I train with a personal trainer?',
          content:
            'Yes — our certified trainers will work with you to create a personalized plan based on your goals. One-on-one and small-group training options will be available.',
        },
      ],
    },
    {
      title: 'Tripods, Filming, and Content Creation Policy',
      items: [
        {
          title: 'Can I film my workout at Fitness Factory?',
          content:
            'Yes, in limited situations, as long as it is safe, respectful, and does not capture other members without permission.',
        },
        {
          title: 'Are tripods allowed?',
          content:
            'Yes, but only small tripods are permitted. Tripods must be 36 inches tall or less. No light stands, large tripods, or multi piece rigs. Tripods cannot block walkways or create safety hazards. Staff may require you to remove the tripod if it is disruptive or unsafe.',
        },
        {
          title: 'Where is filming not allowed, ever?',
          content:
            'Filming and photography are strictly prohibited in locker rooms and other private areas.',
        },
        {
          title: 'Can I record in group classes?',
          content:
            'No filming during group fitness classes unless the instructor and club management explicitly approve it in advance.',
        },
        {
          title: 'What if other people end up in the background?',
          content:
            'Do not record if other members can appear in the frame unless you have their clear permission. If someone appears and asks you to stop, you must stop immediately.',
        },
        {
          title: 'Can I film content for my business or social media coaching page?',
          content:
            'Commercial filming is not allowed without prior written approval from club management. This includes filming to promote a product, service, or coaching business.',
        },
        {
          title: 'What happens if someone reports a filming violation?',
          content:
            'Staff may require you to stop recording, delete content recorded in violation of policy, or leave the club. Repeated or severe violations may result in membership suspension or cancellation.',
        },
      ],
    },
    {
      title: 'Contact & Support',
      items: [
        {
          title: 'How can I contact you?',
          content:
            'For pre-sale or general inquiries, email us at <a href="mailto:careharlem@fitnessfactorygym.com">careharlem@fitnessfactorygym.com</a> or call us at <a href="tel:+12125007444">(212) 500–7444</a> Our team is happy to help with anything you need and will respond as soon as possible.For pre-sale or general inquiries, use the contact form on our website or email/call us once the club officially opens. Our team is happy to help with anything you need.',
        },
      ],
    },
  ];
  
  
  faqs: any[] = [];

  expandedIndex = 0;

  constructor(private _environmentService: EnvironmentService) { }

  ngOnInit(): void {
    this.facilityConfig = this._environmentService.getFacilityConfig();
    this.faqs = this.defaultFaqs;

    if (this.facilityConfig.submerchant === 'dropfitness') {
      this.faqs = this.dropfitnessFaqs;
    } else if (this.facilityConfig.submerchant === 'steelhaus') {
      this.faqs = this.steelhausFaqs;
    } else if (this.facilityConfig.submerchant === 'fitnessfactory') {
      this.faqs = this.fitnessfactoryFaqs;
    }
  }

}
